import apiService from "./globalService"
import { useParams } from "react-router-dom";

export const MediaService = ()=> {

    const params = useParams()
    const lang = params.lang;

    return {
        getAll: (categoryId: number) => {
            return apiService.get(`/wp-json/wp/v2/media`, {
                params: { media_category: categoryId, lang }
            });
        },
        get:(id:number)=>{
            return apiService.get(`/wp-json/wp/v2/media/${id}`, {
                params: { lang }
            });
        },
        getCategories:()=>{
            return apiService.get(`/wp-json/wp/v2/media_category?lang=${lang}`);
        },
        getMediaByCategory: (categoryId: number) => {
            return apiService.get(`/wp-json/wp/v2/media`, {
                params: { media_category: categoryId, lang }
            });
        },
        getAllCategories:()=>{
            return apiService.get(`/wp-json/wp/v2/media_category`);
        }
    }
}

